import Api from 'services/api'
import * as types from '../../constants/action_types'
import { createNotification } from '../notifications'

export const setPromotionSettings = data => async dispatch => {
  dispatch({ type: types.SET_PROMOTION_SETTINGS_DATA, payload: data })
}

export const updatePromotionSettings = () => async (dispatch, getState) => {
  const {
    data: updatedPromotionSetting,
    save: { isLoading }
  } = getState().settings.promotionSettings

  if (isLoading) {
    return
  }

  dispatch({
    type: types.PENDING_PROMOTION_SETTINGS_ACTION,
    payload: 'save'
  })

  const res = await Api.updatePromotionSettings(updatedPromotionSetting)

  if (res.ok) {
    dispatch({
      type: types.SET_PROMOTION_SETTINGS_DATA,
      payload: res.data.notification_settings
    })

    dispatch({
      type: types.COMPLETED_PROMOTION_SETTINGS_ACTION,
      payload: 'save'
    })

    setTimeout(() => {
      dispatch({
        type: types.RESET_PROMOTION_SETTINGS_ACTION,
        payload: 'save'
      })
    }, 2000)
  } else {
    dispatch(
      createNotification({
        message: res.error,
        level: 'error',
        title: 'Promotion Settings Error'
      })
    )

    dispatch({
      type: types.RESET_PROMOTION_SETTINGS_ACTION,
      payload: 'save'
    })
  }
}
